import React from 'react';
import TileImport from '../../Components/Widgets/TileImport/TileImport';

const LandingPage = (props) => {
  const { organization, tiles } = props;
  const tileItems = [
    {
      id: 'PingNationArccosGameInsightsWidget',
      enabled: tiles.indexOf('insights') > -1,
      importFile: process.env.REACT_APP_PING_NATION_ARCCOS_GAME_INSIGHTS,
      addDiv: process.env.REACT_APP_ENABLE_TILE_DIV === 'true',
    },
    {
      id: 'PingNationSubscriptionsWidget',
      enabled: tiles.indexOf('subscription') > -1,
      importFile: process.env.REACT_APP_PING_NATION_SUBSCRIPTIONS,
      addDiv: process.env.REACT_APP_ENABLE_TILE_DIV === 'true',
    },
    {
      id: 'PingNationClubRegistrationWidget',
      enabled: tiles.indexOf('clubreg') > -1,
      importFile: process.env.REACT_APP_PING_NATION_CLUB_REGISTRATION,
      addDiv: process.env.REACT_APP_ENABLE_TILE_DIV === 'true',
    },
    {
      id: 'PingNationWebfitWidget',
      enabled: tiles.indexOf('webfit') > -1,
      importFile: process.env.REACT_APP_PING_NATION_WEBFIT,
      addDiv: process.env.REACT_APP_ENABLE_TILE_DIV === 'true',
    },
    {
      id: 'PingNationEventsWidget',
      enabled: tiles.indexOf('events') > -1,
      importFile: process.env.REACT_APP_PING_NATION_EAS,
      addDiv: process.env.REACT_APP_ENABLE_TILE_DIV === 'true',
    },
  ];

  return (
    <div>
      {tileItems.map((tile, i) => {
        return tile.enabled && <TileImport
          key={i}
          id={tile.id}
          importFile={tile.importFile}
          addDiv={tile.addDiv}
          organization={organization}
        />;
      })}
    </div>
  );
};

export default LandingPage;
